<template>
    <div class="container">
        <div class="row align-items-start py-5">

            <div class="col-sm-6 order-1 order-sm-2">

                <div class="img-effect img-effect-solid mb-5 mb-md-0">
                <img src="/assets/images/info-01.jpg" class="img-fluid w-100" alt="...">
                </div>

            </div>
            <div class="col-sm-6 order-2 order-sm-1">

                <h2 class="mb-4">
                Bilirsinizmi ?
                </h2>

                <p class="text-muted">
                    Şərabın nadir xüsusiyyətlərindən biri, ay işığının fermentasiya prosesinə təsir edə bilməsidir. Araşdırmalara görə, tam ay işığında saxlanılan şərabların fermentasiya prosesləri daha intensiv ola bilər. Bu fenomen, “ay şərabı” adlanan xüsusi içki növü ilə əlaqələndirilir. Ay işığının, şərabın dadına və keyfiyyətinə incə təsir etməsi mümkün olsa da, bu təsir elmi baxımdan tam sübut olunmamışdır və daha çox mistik hesab olunur. Buna baxmayaraq, bəzi şərab istehsalçıları məhsullarının müəyyən mərhələlərində ayın dövrlərini izləməyi və istifadə etməyi adət ediblər.
                </p>

                <!-- <a href="#modal-video" data-toggle="modal" class="btn btn-outline-primary btn-circle mr-3">
                    <i class="fas fa-play"></i>
                </a> Play video -->

            </div>
        </div>

        <!-- <hr class="text-danger" /> -->

        <div class="row align-items-start py-5">

            <div class="col-sm-6 order-1">

                <div class="img-effect img-effect-solid mb-5 mb-md-0">
                <img src="/assets/images/info-02.jpg" class="img-fluid w-100" alt="...">
                </div>

            </div>
            <div class="col-sm-6 order-2">

                <h2 class="mb-4">
                Bəs bunu bilirsinizmi ?
                </h2>

                <p class="text-muted">
                    Şərabın mağazalarda satılması ilə bağlı maraqlı bir məqam onun saxlanma şəraitidir. Şərabın keyfiyyətinin qorunması üçün mağazalarda temperatur və rütubət səviyyəsinin düzgün tənzimlənməsi vacibdir. İdeal temperatur 10-15°C arasında, rütubət isə 60-70% civarında olmalıdır. Bu şərait şərabın dadının və aromasının uzun müddət qorunmasına kömək edir. Həmçinin, şərab şüşələri birbaşa günəş işığından uzaq saxlanılmalı və üfüqi vəziyyətdə yerləşdirilməlidir ki, mantar qurumasın və hava daxil olmasın. Bu qaydalara əməl etmək mağazalarda satılan şərabın keyfiyyətini qorumaq üçün əhəmiyyətlidir.
                </p>

                <!-- <a href="#modal-video" data-toggle="modal" class="btn btn-outline-primary btn-circle mr-3">
                    <i class="fas fa-play"></i>
                </a> Play video -->

            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "DoubleInfoC",
    setup() {
        return {};
    },
}
</script>
